export function getUtmSource(): string {
  // Prefer the actual host for UTM.
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const hostname = window.location.hostname
      .toLowerCase()
      .replace(/^www\./, '')
    const parts = hostname.split('.')
    // Quartz (qz.com / qz.onenews.com) reports as "discover".
    if (parts[0] === 'qz') {
      return 'discover'
    }
    if (parts.length >= 2) {
      parts.pop() // Remove the last part (TLD). Assumes it's always '.com'.
      return parts.join('.')
    }

    return hostname
  }

  // Fallback
  const { settings } = useGlobalLayoutSettings()
  const siteDomain = (settings?.siteName ?? '').toLowerCase()

  if (siteDomain === 'onenews' || !siteDomain) return 'onenews'
  if (siteDomain === 'shiftnews') return 'shiftnews'
  return `${siteDomain}.onenews`
}
